import { loadState } from "../../localStorage";

export const getSessionToken = () =>
  loadState() ? loadState().sessionToken : "";
